export const VALID_PHONE_NUMBER_LENGTH = 10;
export const VALID_ZIP_CODE_MIN_LENGTH = 5;
export const VALID_ZIP_CODE_MAX_LENGTH = 9;

/**
 * Used primarily for the ValidInputText component.
 */
export const handleTextInputValue = (type: string | undefined, val: any): string => {
    type = typeof type === 'undefined' ? 'text' : type; // default to 'text' type
    let value = val;
    switch (type) {
        case 'text':
        case 'Integer':
            return value;
        case 'Ndc':
            value = typeof val === 'string' ? val.replace(/[^0-9]+/g, '') : '';
            return value;
        case 'Phone/Fax':
            value = val.replace(/-/g, '');
            /** Only update internal value if character count does not exceed a valid 10 digit phone. */
            return value.slice(0, VALID_PHONE_NUMBER_LENGTH);
        case 'Zip':
            value = val.replace(/-/g, '');
            /** Only update internal value if character count does not exceed a valid 9 digit zip. */
            return value.slice(0, VALID_ZIP_CODE_MAX_LENGTH);
        default:
            return value;
    }
};
